import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asescontact',
  templateUrl: './asescontact.component.html',
  styleUrls: ['./asescontact.component.scss']
})
export class AsescontactComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
